import { Feather } from '@expo/vector-icons';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from '@react-navigation/native';
import React, { useEffect, useState } from 'react';
import { Text, useWindowDimensions, View } from 'react-native';
import { RectButton, ScrollView, TouchableOpacity } from 'react-native-gesture-handler';
import { Part } from '../../entities/Part';
import { titleCase } from '../../helpers';
import { getAllPartsUseCase } from '../../useCases/GetAllParts';
import styles from './styles';

const Sections: React.FC = () => {

  const [parts, setParts] = useState<Part[]|null>(null);
  const { goBack, navigate } = useNavigation();
  const width = useWindowDimensions().width < 500 ? '100%' : 500;


  async function loadParts() {
    const allParts = await getAllPartsUseCase.execute();

    return allParts;
  }
  
  async function loadPartsApi() {
    const response = await AsyncStorage.getItem('parts');

    let allParts;

    if (response) {
      allParts = JSON.parse(response);
      return allParts;
    }

    allParts = await getAllPartsUseCase.execute();

    await AsyncStorage.setItem('parts', JSON.stringify(allParts));

    return allParts;
  }

  useEffect(() => {
    (async () => {
      const allParts = await loadParts();
      setParts(allParts);
    })();
  }, []);

  return (
    <View 
      style={[
        styles.mainContainer,
        {
          width
        }
      ]}
    >
      <View style={styles.header}>
        <TouchableOpacity
          onPress={() => goBack()} 
        >
          <Feather name="arrow-left" size={28} />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Catecismo da Igreja Católica</Text>
      </View>

      <ScrollView contentContainerStyle={styles.sections}>
        {
          parts 
          ? parts.map((part, index)=> {
            let title = part.title.split(" - ").pop();

            title = title == undefined ? title : titleCase(title);

            const normalFunction = () => navigate('Chapters', { part, partIndex: index });
            const prologueFunction = () => navigate('Reading', { partIndex: 0, sectionIndex: 0, comeFromHome: false })

            const handlePress = index === 0 ? prologueFunction : normalFunction;

            return (
              <RectButton 
                style={styles.section}
                onPress={handlePress}
                key={index}
              >
                <View style={styles.sectionIconView}>
                  <Feather 
                    name="book" 
                    size={26}
                    color="#fff"
                  />
                </View>
                <Text style={styles.sectionTitle}>
                  {index === 0 ? '' : `${index}. `}{title}
                </Text>
              </RectButton>
            );
          })
          : <Text style={{
            fontSize: 20
          }}>
            Carregando...
          </Text>
        }
      </ScrollView>
    </View>
  );
};

export default Sections;